var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEmail24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_email_24x24",
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46753",
    "data-name": "Path 46753",
    d: "M14.4,42.667H1.6a1.648,1.648,0,0,0-1.128.44,1.447,1.447,0,0,0-.464,1.06l-.008,9a1.552,1.552,0,0,0,1.6,1.5H14.4a1.552,1.552,0,0,0,1.6-1.5v-9a1.552,1.552,0,0,0-1.6-1.5Zm0,3L8,49.417l-6.4-3.75v-1.5L8,47.917l6.4-3.75Z",
    transform: "translate(4 -37.667)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEmail24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_email_24x24.8b2f05073eb5d08bcb9d381bb9166f7b.svg";